import { BlockTypes } from '../../models/block.js';

function mapApiResponseToCourseModel(user, remote) {
  return {
    __internalId: remote.objectID,
    id: remote.objectID,
    ownerId: (remote.userID || user?.id) ?? "",
    createdAt: new Date(remote.created * 1000),
    modifiedAt: new Date(remote.modified * 1000),
    title: remote.title,
    subjects: remote.subjects,
    levels: remote.levels,
    shared: remote.clonedFrom ? {
      clonedFromId: remote.clonedFrom
    } : undefined,
    blocks: mapBlocks(remote.courseElements ?? [])
  };
}
function mapBlocks(blocks) {
  return blocks?.map(rawBlock => {
    const baseBlock = {
      id: rawBlock.id,
      title: rawBlock.title,
      note: {
        enabled: rawBlock.note.isVisible,
        content: rawBlock.note.content
      }
    };
    switch (rawBlock.type) {
      case BlockTypes.EMBED:
        return mapEmbedBlock(baseBlock, rawBlock);
      case BlockTypes.LINK:
        return mapLinkBlock(baseBlock, rawBlock);
      case BlockTypes.REFERENCE:
        return mapReferenceBlock(baseBlock, rawBlock);
      case BlockTypes.RICHTEXT:
        return mapRichtextBlock(baseBlock, rawBlock);
      case BlockTypes.YOUTUBE:
        return mapYoutubeBlock(baseBlock, rawBlock);
      default:
        throw new Error(`mapBlocks(${rawBlock.type}): Unable to determine type of block.`);
    }
  }).filter(it => it !== undefined);
}
function mapEmbedBlock(baseBlock, block) {
  try {
    const content = JSON.parse(block.content);
    return {
      type: BlockTypes.EMBED,
      ...baseBlock,
      ...content
    };
  } catch (err) {
    console.log(err);
  }
}
function mapLinkBlock(baseBlock, block) {
  try {
    const content = JSON.parse(block.content);
    return {
      type: BlockTypes.LINK,
      ...baseBlock,
      ...content
    };
  } catch (err) {
    console.log(err);
  }
}
function mapReferenceBlock(baseBlock, block) {
  try {
    const content = JSON.parse(block.content);
    return {
      type: BlockTypes.REFERENCE,
      ...baseBlock,
      ...content
    };
  } catch (err) {
    console.log(err);
  }
}
function mapRichtextBlock(baseBlock, block) {
  try {
    const content = JSON.parse(block.content);
    return {
      type: BlockTypes.RICHTEXT,
      ...baseBlock,
      ...content
    };
  } catch (err) {
    console.log(err);
  }
}
function mapYoutubeBlock(baseBlock, block) {
  try {
    const content = JSON.parse(block.content);
    return {
      type: BlockTypes.YOUTUBE,
      ...baseBlock,
      ...content
    };
  } catch (err) {
    console.log(err);
  }
}

export { mapApiResponseToCourseModel };
//# sourceMappingURL=api-to-course.js.map
